/* LUCRÜ™ — © 2026 LUCRÜ. All rights reserved. */
import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export const getOrCreateSession = () => {
  let s = localStorage.getItem("golucru_session");
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || Math.random().toString(36).slice(2);
    localStorage.setItem("golucru_session", s);
  }
  return s;
};

export const wsChatUrl = (sessionId) => {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws/chat/${sessionId}`;
};
